import React from 'react';
import {Icon} from 'semantic-ui-react';
import Paper from 'material-ui/Paper';

export class WelcomePage extends React.Component {
	render() {
		return (
			<Paper zDepth={1} style={{marginBottom: '20px', paddingTop: '20px', minHeight: '500px'}}>
				<p className="center bold" style={{fontWeight: '800', fontSize: '18px'}}>
					Welcome to Chated.io's Abandoned Cart App!
				</p>
				<br />
				<p className="center" style={{padding: '15px'}}>
					<Icon color="blue" name="shopping cart" size="huge" />
				</p>
				<br />
				<p className="center" style={{marginBottom: '0px', fontSize: '16px'}}>
					When shoppers abandon their carts in your shop, you're able to send emails to remind them of the items they left behind.
				</p>
				<br />
				<p className="center" style={{padding: '15px'}}>
					<Icon color="blue" name="mail outline" size="huge" />
				</p>
				<br />
				<p className="center" style={{marginBottom: '0px', fontSize: '16px'}}>
					Our emails are highly customizable!
				</p>
				<p className="center" style={{marginBottom: '0px', fontSize: '16px'}}>
					In the next step, you will be asked to configure the emails that will be sent out.
				</p>
				<p className="center" style={{marginBottom: '0px', fontSize: '16px'}}>
					Don't worry you can configure them any time!
				</p>
			</Paper>
		);
	}
}

export default WelcomePage;



// WEBPACK FOOTER //
// ./src/containers/template-boarding-page/welcome-page.js